
function makePropsEnumerable(obj, propNames) {
    let propsDefinition = {};
    propNames.forEach(function(propName) {
        propsDefinition[propName] = {
            enumerable: true
        };
    });

    Object.defineProperties(obj, propsDefinition);
}

export default makePropsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./src/utility/MakePropsEnumerable.js
// module id = kYlS
// module chunks = 1